<div class="teaser-item">
  <a
    class="relative teaser-link elevation-level-1 elevation-transition-ease elevation-highlight fill flex flex--column no-underline radius-small overflow-hidden"
    tabindex="0"
    (click)="emitClick()"
    [finLink]="content().url"
  >
    <div class="teaser-image">
      @for (teaserImage of getPics(content().media); track teaserImage.contentId) {
        <fin-block-image [aspectRatio]="aspectRatio()" [imageData]="teaserImage" />
      }
    </div>
    <div class="fill white-bg surface-primary ps-large-y ps-medium-x teaser-text-content flex flex--column flex-1">
      @if (content().teaserTitle) {
        <h3 class="teaser-title ms-clear-t nordic-blue-900-text text-icon-primary font-body-medium-bold">
          {{ content().teaserTitle }}
        </h3>
      }
      <fin-date class="flex flex--align-end teaser-date" [date]="content().externallyDisplayedDate" />
    </div>
  </a>
</div>
